const FONT_PRIMARY = "'Plus Jakarta Sans', sans-serif";
// Add to public/index.html <head>:
// <link href="https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap" rel="stylesheet">
const typography = {
  fontFamily: FONT_PRIMARY,
  fontWeightRegular: 400, fontWeightMedium: 500, fontWeightBold: 700,
  h1: { fontWeight: 800, lineHeight: 1.2,  fontSize: '2.5rem'  },
  h2: { fontWeight: 700, lineHeight: 1.25, fontSize: '2rem'    },
  h3: { fontWeight: 700, lineHeight: 1.3,  fontSize: '1.5rem'  },
  h4: { fontWeight: 700, lineHeight: 1.35, fontSize: '1.25rem' },
  h5: { fontWeight: 600, lineHeight: 1.4,  fontSize: '1.05rem' },
  h6: { fontWeight: 600, lineHeight: 1.5,  fontSize: '0.9rem'  },
  subtitle1: { fontWeight: 600, lineHeight: 1.5,  fontSize: '1rem'     },
  subtitle2: { fontWeight: 600, lineHeight: 1.57, fontSize: '0.875rem' },
  body1:  { lineHeight: 1.6, fontSize: '0.9375rem' },
  body2:  { lineHeight: 1.6, fontSize: '0.875rem'  },
  caption:{ lineHeight: 1.5, fontSize: '0.75rem'   },
  overline: { fontWeight: 700, letterSpacing: '0.08em', fontSize: '0.65rem', textTransform: 'uppercase' },
  button:   { fontWeight: 600, letterSpacing: '0.01em', fontSize: '0.875rem' },
};
export default typography;
